export default __webpack_public_path__ + "static/media/art_work.4e7bb315.svg";